import { getSession } from '../../utils/auth'
import { logError } from '../../utils/errors'
import { getSessionRequestAction, getSessionSuccessAction } from './session'

/**
 * Handle auth error middleware
 */
export default next => {
  return dispatch => {
    // token expired, let's try get session again.
    dispatch(getSessionRequestAction())
    getSession()
      .then(res => {
        return res.data.token
      })
      .then(jwtToken => {
        dispatch(getSessionSuccessAction(jwtToken))
        dispatch(next)
      })
      .catch(logError)
  }
}



// WEBPACK FOOTER //
// ./common/actions/user/authMiddleware.js